import React, {Component} from "react";
import SportIcon from "../../../components/SportIcon";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import ACTIONS from "../../../constants/actions";

class EventHeader extends Component {
	static propTypes = {
		sport : PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);
	}

	toggleFavorite() {
		const {sport, events} = this.props;

		// добавляем спорт в хранилище
		this.props.toggleFavoriteSports(sport.id);

		// выбираем все события у спорта
		const selected = events.map((event) => event.id);

		// добавляем эти события в хранилище
		this.props.toggleFavorite(selected);
	}

	render() {
		const {sport, favoriteSports} = this.props;

		return (
			<div className={`events__header thead`}>
				<div className="tr">
					<div className="th favorite">
						<span className={`stars ${(favoriteSports.indexOf(this.props.sport.id) !== -1) && 'activated'}`}
						      onClick={this.toggleFavorite.bind(this)}>
						</span>
					</div>
					<div className="th sportname">
						{/*{green}*/}
						<span className="sport-icon small green events__header__sporticon">
							<SportIcon sportId={sport.id}/>
						</span>
						<span>&nbsp;<Link to={`live-sport/${sport.id}`}>{sport.name}</Link></span>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		favoriteSports : state.favoriteSports
	}),
	dispatch => ({
		toggleFavorite       : (data) => {
			dispatch({type : ACTIONS.FAVORITES.TOGGLE, data : data})
		},
		toggleFavoriteSports : (data) => {
			dispatch({type : ACTIONS.FAVORITE_SPORTS.TOGGLE, data : data})
		}
	})
)(EventHeader);


// WEBPACK FOOTER //
// ./src/app/pages/Main/Events/EventHeader.js